module.exports = __webpack_public_path__ + "static/final-tpm-3-45067240c224f129997a47fab820b9dc.jpg";